/**
 * PortfolioPageSkeleton - Skeleton loader for portfolio page
 * Matches the layout of PortfolioSummaryCard, TopMoversCard, PerformanceChartCard, and InvestmentTableCard
 */

import React from 'react';

export const PortfolioPageSkeleton: React.FC = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {/* Portfolio Summary Card Skeleton (spans 2 columns) */}
      <div className="md:col-span-2">
        <div className="bg-white rounded-lg p-6 shadow-sm animate-pulse h-full flex flex-col">
          <div className="mb-4">
            <div className="h-6 bg-gray-200 rounded w-48"></div>
          </div>
          <div className="flex items-center justify-around flex-1">
            {/* Mini Donut Chart Skeleton */}
            <div className="w-16 h-16 rounded-full bg-gray-200"></div>
            
            {/* Stats Skeleton */}
            <div className="space-y-2">
              <div className="h-4 bg-gray-200 rounded w-24"></div>
              <div className="h-6 bg-gray-200 rounded w-32"></div>
            </div>
            <div className="space-y-2">
              <div className="h-4 bg-gray-200 rounded w-24"></div>
              <div className="h-6 bg-gray-200 rounded w-32"></div>
            </div>
            <div className="space-y-2">
              <div className="h-4 bg-gray-200 rounded w-24"></div>
              <div className="h-6 bg-gray-200 rounded w-32"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Top Movers Card Skeleton */}
      <div>
        <div className="bg-white rounded-lg p-6 shadow-sm animate-pulse h-full flex flex-col">
          <div className="mb-4">
            <div className="h-6 bg-gray-200 rounded w-40"></div>
          </div>
          {/* Horizontal list of tickers (matching actual TopMoversCard layout) */}
          <div className="flex space-x-4 flex-1 items-start">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="flex-shrink-0 w-20 text-center space-y-1">
                {/* Ticker symbol (large, bold) */}
                <div className="h-5 bg-gray-200 rounded w-full"></div>
                {/* Company name (smaller) */}
                <div className="h-3 bg-gray-200 rounded w-full"></div>
                {/* Percentage change (smaller) */}
                <div className="h-4 bg-gray-200 rounded w-12 mx-auto"></div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Performance Chart Card Skeleton (spans 2 columns) */}
      <div className="md:col-span-2">
        <div className="bg-white rounded-lg p-6 shadow-sm animate-pulse h-full flex flex-col">
          <div className="mb-4 flex items-center justify-between">
            <div className="h-6 bg-gray-200 rounded w-48"></div>
            <div className="h-8 bg-gray-200 rounded w-24"></div>
          </div>
          <div className="h-64 bg-gray-200 rounded flex-1"></div>
        </div>
      </div>

      {/* Investment Table Card Skeleton */}
      <div>
        <div className="bg-white rounded-lg p-6 shadow-sm animate-pulse h-full flex flex-col">
          <div className="mb-4">
            <div className="h-6 bg-gray-200 rounded w-40"></div>
          </div>
          <div className="space-y-3 flex-1">
            {[1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="space-y-2">
                <div className="h-4 bg-gray-200 rounded w-full"></div>
                <div className="h-3 bg-gray-200 rounded w-3/4"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
